// tslint:disable:max-line-length

import React from 'react';

export const ArrowRightSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="8.7,2 14,8 8.7,14 8,13.3 12.3,8.5 2,8.5 2,7.5 12.3,7.5 8,2.7 8.7,2" />
    </svg>
  );
};
